import {Profile} from 'feedback-system/dto/IProfile';

export const sortProfilesByName = (a: Profile, b: Profile) => {
    const nameA = `${a.firstName} ${a.lastName}`;
    const nameB = `${b.firstName} ${b.lastName}`;
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }
    return 0;
};
